import React from "react";
import { imgUrl } from "../../lib/format";

/**
 * Canonical product image component. Use everywhere the site renders a bottle
 * (cards, hero, cart, admin) so alignment, sizing, and cache-busting are
 * identical across the codebase.
 *
 * The normalized master images already:
 *   - center every bottle horizontally at x=600
 *   - align every vial bottom to y=1080
 *   - scale every bottle to ~900px visual height on a 1200x1200 canvas
 * So the frontend must ONLY use object-contain inside an aspect-square box.
 */
export const ProductImage = ({
  product,
  size = "standard", // "thumbnail" | "standard" | "zoom"
  className = "",
  padding = "p-4",   // Tailwind padding classes
  testId,
  eager = false,
}) => {
  const urlByField = {
    thumbnail: product.thumbnail_image_url,
    standard: product.primary_image_url,
    zoom: product.zoom_image_url,
  };
  const src = urlByField[size] || product.primary_image_url;
  const isPlaceholder = product.image_match_status === "Missing Image";

  return (
    <div
      className={`relative aspect-square w-full overflow-hidden bg-brand-surface ${className}`}
      data-testid={testId || `product-image-${product.slug}`}
    >
      <img
        src={imgUrl(src)}
        alt={product.image_alt_text || `${product.product_name} ${product.strength} bottle`}
        className={`absolute inset-0 h-full w-full object-contain object-center ${padding}`}
        loading={eager ? "eager" : "lazy"}
        decoding="async"
        width={1200}
        height={1200}
      />
      {isPlaceholder && (
        <div className="absolute top-3 left-3 text-[10px] font-semibold uppercase tracking-[0.14em] bg-amber-50 border border-amber-200 text-amber-800 px-2 py-1 rounded-full">
          Image coming
        </div>
      )}
    </div>
  );
};
